<template>
    <div class="form-group clearfix">
        <div class="col-md-6">
            <label v-text="trans('date_picker_from')"></label> <span class="text-muted small">(00:00:00)</span>
            <input type="text" name="date_start" v-model="date_start" id="datepicker_start" class="form-control" autocomplete="off">
        </div>
        <div class="col-md-6">
            <label v-text="trans('date_picker_to')"></label> <span class="text-muted small">(23:59:59)</span>
            <input type="text" name="date_finish" v-model="date_finish" id="datepicker_finish" class="form-control" autocomplete="off">
        </div>
    </div>
</template>

<script>
    import * as Functions from '../Functions';

    export default {
        props: ['translations'],
        mounted: function() {
            $("#datepicker_start").on(
                "changeDate", () => {this.date_start = document.getElementById('datepicker_start').value}
            );
            $("#datepicker_finish").on(
                "changeDate", () => {this.date_finish = document.getElementById('datepicker_finish').value}
            );
        },
        data: function () {
            return {
                date_start: '',
                date_finish: ''
            };
        },
        methods: {
            trans(name, path = null) {
                return Functions.trans(this.translations, name, path);
            },
        },
        watch: {
            'date_start' : function(val) {
                this.$emit('update-date', {'date_start': val, 'date_finish': this.date_finish});
                this.$root.$emit('update:date_range', {'date_start': val, 'date_finish': this.date_finish});
            },
            'date_finish' : function(val) {
                this.$emit('update-date', {'date_start': this.date_start, 'date_finish': val});
                this.$root.$emit('update:date_range', {'date_start': this.date_start, 'date_finish': val});
            }
        }
    }
</script>
